import api from '../api';
import { unwrapCourseCatalog } from '@/utils/courses';

export default {
    async getDataCourses(accessToken, params = {}) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/course`,  {
                headers,
                params,
            });
            return unwrapCourseCatalog(response.data);
        } catch (error) {
            console.error('Erro ao carregar cursos do aluno:', error);
                throw error;
        }
    },
    

    async getDataCourse(accessToken, id) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/course/${id}`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar dados do Curso', error);
                throw error;
        }
    },

    async getBannerPortal(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/website`,  {
                headers,
            });
            return response.data.portalBannerFinalPath;
        } catch (error) {
            console.error('Erro ao carregar banner do portal:', error);
        }   
    }

}

